<h3 mat-dialog-content>Dodaj wpłacającego</h3>
<mat-dialog-content>
	<mat-radio-group *ngIf="!data.ownerUser" class="d-flex flex-row gap-2 mt-3" [(ngModel)]="selectedCustomerType">
		<mat-radio-button (change)="changeSelectedData(true)" [value]="customerType.PRIVATE"
			>Klient indywidualny</mat-radio-button
		>
		<mat-radio-button (change)="changeSelectedData(false)" [value]="customerType.COMPANY">Firma</mat-radio-button>
	</mat-radio-group>
	<div class="row w-50 mx-auto mt-3" *ngIf="!data.ownerUser">
		<ng-container *ngIf="selectedCustomerType === customerType.PRIVATE">
			<mat-form-field appearance="outline">
				<mat-label>Wyszukaj</mat-label>
				<input type="text" matInput [matAutocomplete]="autoUser" />
				<mat-autocomplete #autoUser="matAutocomplete">
					<mat-option *ngFor="let user of filteredUsers" [value]="user.id">
						{{ user.firstName }} {{ user.lastName }}
					</mat-option>
				</mat-autocomplete>
			</mat-form-field>
		</ng-container>
		<ng-container *ngIf="selectedCustomerType === customerType.COMPANY">
			<mat-form-field appearance="outline">
				<mat-label>Wyszukaj firmy</mat-label>
				<input type="text" matInput [matAutocomplete]="auto" />
				<mat-hint *ngIf="selectedCustomerType === customerType.COMPANY" align="end"> Wpisz NIP, nazwe</mat-hint>
				<mat-autocomplete #auto="matAutocomplete">
					<ng-container>
						<mat-option *ngFor="let organization of filteredOrganizations" [value]="organization.id">
							{{ organization.name }}
						</mat-option>
					</ng-container>
				</mat-autocomplete>
			</mat-form-field>
		</ng-container>
	</div>

	<ng-container>
		<div class="d-flex flex-row gap-2">
			<mat-form-field appearance="outline">
				<mat-label>Zwrot grzecznościowy</mat-label>
				<mat-select [(ngModel)]="data.profile.sex" required placeholder="Pan">
					<mat-option value="M">Pan</mat-option>
					<mat-option value="K">Pani</mat-option>
				</mat-select>
			</mat-form-field>
			<mat-form-field appearance="outline">
				<mat-label>Imię</mat-label>
				<input type="text" [(ngModel)]="data.profile.first_name" matInput required />
			</mat-form-field>
			<mat-form-field appearance="outline">
				<mat-label>Nazwisko</mat-label>
				<input type="text" [(ngModel)]="data.profile.last_name" matInput required />
			</mat-form-field>
			<mat-form-field appearance="outline" class="example-form-field">
				<mat-label>Data urodzenia</mat-label>
				<input matInput [(ngModel)]="data.birth" [matDatepicker]="datepicker" />
				<mat-hint>MM/DD/YYYY</mat-hint>
				<mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
				<mat-datepicker #datepicker>
					<mat-datepicker-actions>
						<button mat-button matDatepickerCancel>Anuluj</button>
						<button mat-raised-button color="primary" matDatepickerApply>Zatwierdź</button>
					</mat-datepicker-actions>
				</mat-datepicker>
			</mat-form-field>
			<mat-form-field appearance="outline">
				<mat-label>Obywatelstwo</mat-label>
				<mat-select [(ngModel)]="data.profile.nationality">
					<mat-option></mat-option>
				</mat-select>
			</mat-form-field>
		</div>
		<div class="d-flex flex-row gap-2 mt-1">
			<mat-form-field appearance="outline">
				<mat-label>Typ dokumentu</mat-label>
				<mat-select [(ngModel)]="data.documentType" (selectionChange)="changeDocumentType($event)">
					<mat-option [value]="null"></mat-option>
					<mat-option [value]="0">Dowód osobisty</mat-option>
					<mat-option [value]="1">Paszport</mat-option>
				</mat-select>
			</mat-form-field>
			<mat-form-field appearance="outline">
				<mat-label>Numer dokumentu</mat-label>
				<input
					type="text"
					[(ngModel)]="data.documentNumber"
					[disabled]="data.documentType === null"
					[required]="data.documentType !== null"
					matInput
				/>
			</mat-form-field>
			<mat-form-field appearance="outline">
				<mat-label>Adres e-mail</mat-label>
				<input type="text" [(ngModel)]="data.userContact.email" matInput />
			</mat-form-field>
			<mat-form-field appearance="outline">
				<input matInput type="text" [(ngModel)]="data.userContact.phone" placeholder="Numer telefonu" />
			</mat-form-field>
		</div>
	</ng-container>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button mat-button (click)="cancel()">Porzuć</button>
	<button mat-raised-button color="primary" (click)="submit()">Zapisz zmiany</button>
</mat-dialog-actions>
